import { Box, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import { AddMemberPrimaryAddressProps } from './types';
import styles from './styles';
import InputField from '../../common/InputField/InputField';
import CustomSelect from '../../common/Select';
import USState from '../../../utils/USState';
import FormButton from '../../common/FormButton';

const AddMemberPrimaryAddress = ({
    addMemberPrimaryAddress,
    handleCloseAddMemberPrimaryAddress,
    memberPrimaryAddressInfo,
    formErrors,
    handleInput,
    handleSubmit,
    submitting,
}: AddMemberPrimaryAddressProps) => {
    return (
        <FormsPopup
            id="add_member_address"
            open={addMemberPrimaryAddress}
            title="Add Primary Address"
            textAlign="left"
            handleClose={handleCloseAddMemberPrimaryAddress}
            width={662}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <InputField
                            required
                            id="firstname"
                            label="First Name"
                            type="text"
                            name="firstname"
                            placeholder="Type here..."
                            onChange={handleInput}
                            value={memberPrimaryAddressInfo?.firstname}
                            error={formErrors && formErrors.firstname && formErrors.firstname[0] !== ''}
                            errorMessage={formErrors && formErrors.firstname && formErrors.firstname[0]}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputField
                            required
                            id="lastname"
                            label="Last Name"
                            type="text"
                            name="lastname"
                            placeholder="Type here..."
                            onChange={handleInput}
                            value={memberPrimaryAddressInfo?.lastname}
                            error={formErrors && formErrors.lastname && formErrors.lastname[0] !== ''}
                            errorMessage={formErrors && formErrors.lastname && formErrors.lastname[0]}
                            disabled
                        />
                    </Grid>
                </Grid>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography sx={styles.addressField} component="div">
                                <InputField
                                    required
                                    id="address1"
                                    label="Address"
                                    type="text"
                                    name="address1"
                                    placeholder="Type here..."
                                    onChange={handleInput}
                                    value={memberPrimaryAddressInfo?.address1}
                                    error={formErrors && formErrors.address1 && formErrors.address1[0] !== ''}
                                    errorMessage={formErrors && formErrors.address1 && formErrors.address1[0]}
                                />
                            </Typography>
                            <Typography sx={styles.addressField} component="div">
                                <InputField
                                    required
                                    id="city"
                                    label="City"
                                    type="text"
                                    name="city"
                                    placeholder="Type here..."
                                    onChange={handleInput}
                                    value={memberPrimaryAddressInfo?.city}
                                    error={formErrors && formErrors.city && formErrors.city[0] !== ''}
                                    errorMessage={formErrors && formErrors.city && formErrors.city[0]}
                                />
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography sx={styles.addressField} component="div">
                                <InputField
                                    required
                                    id="address2"
                                    label="Apt Number"
                                    type="text"
                                    name="address2"
                                    placeholder="Type here..."
                                    onChange={handleInput}
                                    value={memberPrimaryAddressInfo?.address2}
                                    error={formErrors && formErrors.address2 && formErrors.address2[0] !== ''}
                                    errorMessage={formErrors && formErrors.address2 && formErrors.address2[0]}
                                />
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography sx={styles.addressField2} component="div">
                                        <CustomSelect
                                            name="state"
                                            label="State"
                                            id="state"
                                            handleOnchange={handleInput}
                                            items={USState}
                                            value={memberPrimaryAddressInfo?.state}
                                            error={formErrors && formErrors.state && formErrors.state[0] !== ''}
                                            errorMessage={formErrors && formErrors.state && formErrors.state[0]}
                                            customStyles={{ height: 44 }}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography sx={styles.addressField2} component="div">
                                        <InputField
                                            required
                                            id="zip"
                                            label="Zip Code"
                                            type="text"
                                            name="zip"
                                            placeholder="Type here..."
                                            onChange={handleInput}
                                            value={memberPrimaryAddressInfo?.zip}
                                            error={formErrors && formErrors.zip && formErrors.zip[0] !== ''}
                                            errorMessage={formErrors && formErrors.zip && formErrors.zip[0]}
                                        />
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Grid container justifyContent="center">
                    <FormButton
                        variant="contained"
                        sx={styles.saveButton}
                        type="submit"
                        id="addMemberPrimaryAddress"
                        data-testid="addMemberPrimaryAddress"
                        submitting={submitting}
                    >
                        Save changes
                    </FormButton>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default AddMemberPrimaryAddress;
